import { useEffect } from "react";
import { useQuery } from "react-query";
import { api } from "services/api";
import { AgentAbsence } from "types/SupportAgent";
import { handleRequestError } from "utils/Request";

async function fetchAgentAbsences(userId?: string): Promise<AgentAbsence[]> {
  const { data } = await api.get('/support/absences', {
    params: userId ? { user_id: userId } : {},
  });
  return data;
}

export function useAgentAbsences(userId?: string) {
  const query = useQuery(['agent-absences', userId ?? 'all'], () => fetchAgentAbsences(userId));

  useEffect(() => {
    if (!query.isError) return;
    handleRequestError(query.error, 'Erro ao listar ausências. Tente novamente.');
  }, [query.isError, query.error]);

  return query;
}
